import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-saledeed-details',
  templateUrl: './saledeed-details.component.html',
  styleUrls: ['./saledeed-details.component.css']
})
export class SaledeedDetailsComponent implements OnInit {
  title="Applicant Details";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/allotment-cancellation/saledeed-details/saledeed-details.component.ts